module.exports = __webpack_public_path__ + "static/media/tipsImg22.60f6c97e.png";